import api from '@/utils/api';

export const reviewLabel = object => !object ? 'Нет данных о проверке' : object.status === 'confirmed'
    ? object.origin === 'month' ? 'Подтверждено в составе месяца' : 'Подтверждено'
    : {draft: 'Не подтверждено', review_required: 'Перепроверить', deferred: 'Отложено'}[object.status] || 'Не подтверждено';
export const reviewVariant = object => ({confirmed: 'success', review_required: 'danger', deferred: 'warning'}[(object || {}).status] || 'secondary');

export default {
    data: () => ({reviewFeedback: null, confirmationRows: [], confirmationVisible: false, confirmationReturn: null}),
    watch: {
        groupByObject() { this.selectedLineIds = []; this.reviewFeedback = null; },
        lineStatusFilter() { this.selectedLineIds = []; },
        lineQuery() { this.selectedLineIds = []; },
        periodMonth() { this.confirmationVisible = false; this.confirmationRows = []; this.confirmationReturn = null; this.reviewFeedback = null; }
    },
    computed: {
        visibleReviewRows() {
            return this.displayRuns.flatMap(run => this.payrollGroups(run, {}).flatMap(group => group.lines))
                .filter(line => this.canConfirmLine(line));
        }
    },
    methods: {
        objectReviewFor(line) {
            if (!this.groupByObject || !line._objectView) return null;
            const id = Number((this.lineComponents(line)[0] || {}).building_id) || 0;
            return ((line.object_review || {}).objects || []).find(object => object.building_id === id) || null;
        },
        reviewProgress(line) {
            const value = line.object_review;
            return value ? `Подтверждено ${value.confirmed_count} из ${value.total_count} объектов` : '';
        },
        reviewIsObject(line) { return Boolean(this.groupByObject && line._objectView); },
        reviewKey(line) { return this.reviewIsObject(line) ? `${line.id}:${Number((this.lineComponents(line)[0] || {}).building_id) || 0}` : line.id; },
        reviewDecision(line, scope = this.reviewIsObject(line) ? 'object' : 'month') {
            const original = this.allLines.find(row => row.id === line.id) || line;
            return {line_id: line.id, expected_revision: original.edit_revision,
                ...(scope === 'object' ? {building_id: Number((this.lineComponents(line)[0] || {}).building_id) || 0} : {})};
        },
        objectReviewAvailable(line) {
            const value = line.object_review;
            return value && !value.legacy_month && !value.unavailable && !value.month_hold && !value.global_conflict;
        },
        reviewStatusMatches(line, filter) {
            if (filter === 'paid') return line.payment_status === 'paid';
            const object = this.objectReviewFor(line);
            if (object) {
                if (filter === 'attention') return object.status !== 'confirmed' || Boolean((line.object_review || {}).month_hold);
                if (filter === 'confirmed') return object.status === 'confirmed';
                if (filter === 'deferred') return object.status === 'deferred' || Boolean((line.object_review || {}).month_hold);
            }
            if (filter === 'attention') return line._missingRate || line.review_required || ['draft', 'review_required', 'returned'].includes(line.workflow_status);
            if (filter === 'confirmed') return line.workflow_status === 'confirmed';
            if (filter === 'deferred') return line.workflow_status === 'deferred';
            return true;
        },
        async confirmRow(line) {
            if (!this.reviewIsObject(line)) return this.confirmMonthlyLines([line.id]);
            return this.confirmObjectRows([line]);
        },
        async confirmObjectRows(rows) {
            const decisions = rows.map(line => this.reviewDecision(line, 'object'));
            this.reviewFeedback = null;
            const success = `Подтверждено объектов: ${decisions.length}.`;
            const done = await this.action(() => api.post('/api/payroll/lines/confirm', {scope: 'object', decisions}, {ignoreModal: true}), success);
            this.reviewFeedback = {keys: rows.map(this.reviewKey), error: !done, text: done ? success : this.errorMessage};
            return done;
        },
        async confirmMonthlyLines(ids) {
            if (this.ratesBusy || this.ratesDirty) {
                this.reviewFeedback = {keys: [], error: true, text: 'Сначала сохраните или сбросьте заполнение ставок в списке сотрудников.'};
                this.errorMessage = this.reviewFeedback.text;
                return;
            }
            if (this.pending || !await this.allowEditorLeave()) return;
            if (this.editVisible) await this.finishEditor();
            else if (this.$refs.explanation) this.$refs.explanation.close(false);
            this.confirmationReturn = null;
            this.confirmationRows = ids.map(id => {
                const run = this.summary.runs.find(run => run.lines.some(line => line.id === id));
                return run ? {line: run.lines.find(line => line.id === id), run, month: this.periodMonth} : null;
            }).filter(Boolean);
            this.confirmationVisible = this.confirmationRows.length > 0;
        },
        async editFromConfirmation(context, buildingId) {
            const ids = this.confirmationRows.map(row => row.line.id);
            this.confirmationVisible = false;
            this.confirmationReturn = ids;
            const run = this.summary.runs.find(run => run.id === context.run.id) || context.run;
            let line = run.lines.find(line => line.id === context.line.id) || context.line;
            if (buildingId != null) line = {...line, _objectView: true, _allComponents: this.lineComponents(line),
                calculation_details: {...line.calculation_details, components: this.lineComponents(line).filter(part => (Number(part.building_id) || 0) === buildingId)}};
            await this.$nextTick();
            return this.requestLineEdit(line, run, 'total', {key: buildingId == null ? 'all' : String(buildingId)}, null);
        },
        async reopenConfirmation() {
            const ids = this.confirmationReturn;
            if (ids) await this.confirmMonthlyLines(ids);
        },
        async confirmationSources(context, source) {
            this.confirmationVisible = false;
            await this.$nextTick();
            const line = {...context.line, _objectView: true, calculation_details: {...context.line.calculation_details,
                components: this.lineComponents(context.line).filter(part => (Number(part.building_id) || 0) === source.building_id)}};
            this.$refs.timesheetSources.open(line, context.run, null);
        },
        async confirmationSaved() {
            this.confirmationVisible = false; this.confirmationRows = []; this.selectedLineIds = [];
            await this.loadSummary();
        },
        async resumeReview(line) {
            const scope = this.reviewIsObject(line) ? 'object' : 'month';
            const done = await this.action(() => api.post(`/api/payroll/lines/${line.id}/resume`, {scope, ...this.reviewDecision(line, scope)}, {ignoreModal: true}),
                scope === 'object' ? 'Объект возвращён к рассмотрению. Требуется подтверждение.' : 'Месяц возвращён к рассмотрению.');
            this.reviewFeedback = {keys: [this.reviewKey(line)], error: !done, text: done ? this.successMessage : this.errorMessage};
        },
        reviewLabel, reviewVariant
    }
};
